module.exports = __FOREMAN_VENDOR__FILE_SAVER__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__FILE_SAVER__"
// module id = file-saver
// module chunks = 0 1 2